import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/suppliers", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/suppliers/csv", params);
};

const upsert = data => {
  return restApi.post("/api/suppliers/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/suppliers/${ids}`);
};


const supplierService = {
  getAll,
  getAllForCSV,
  upsert,
  remove,
};

export default supplierService;